import { Help, Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, TextField } from '@mui/material';
import React, { useState } from 'react';
import { MUIFieldProps } from '../../../../../lib/types/types';
import MUIToolTip from '../../../mui-tooltip/MUIToolTip';

const MUITextField: React.FC<MUIFieldProps> = (props) => {
	const { type, label, tooltip, fieldValue, updateFieldValue, isDisabled, error, errorMessage, ...restProps } = props;
	const [showPassword, setShowPassword] = useState(false);

	const sanitizedLabel = label.replace(/\s+/g, '-');
	const errorId = `${sanitizedLabel}-error-text`;
	const tooltipId = `${sanitizedLabel}-tooltip`;
	const ariaDescribedBy =
		error ? errorId
		: tooltip ? tooltipId
		: undefined;

	return (
		<TextField
			fullWidth
			id={`${sanitizedLabel}-input`}
			type={showPassword ? 'text' : type}
			aria-describedby={ariaDescribedBy}
			label={
				<span>
					{label}
					{tooltip && (
						<MUIToolTip title={tooltip} id={tooltipId}>
							<Help fontSize='small' color='primary' sx={{ ml: '5px' }} />
						</MUIToolTip>
					)}
				</span>
			}
			value={fieldValue}
			onChange={updateFieldValue}
			disabled={isDisabled}
			error={error}
			helperText={error ? <span id={errorId}>{errorMessage}</span> : undefined}
			InputProps={{
				endAdornment: type === 'password' && (
					<IconButton
						aria-label={showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'}
						aria-pressed={showPassword}
						onClick={() => setShowPassword(!showPassword)}
					>
						{showPassword ?
							<Visibility />
						:	<VisibilityOff />}
					</IconButton>
				),
			}}
			{...restProps}
		/>
	);
};

export default MUITextField;
